export default __webpack_public_path__ + "static/media/maintenance.38f68ba7.jpg";